export default __webpack_public_path__ + "static/media/chevron-right.feac9341.svg";